import React from 'react';

const QuizProgress = ({ 
  currentStep, 
  totalSteps, 
  categories, 
  completedSteps,
  onStepClick 
}) => {
  const progressPercentage = Math.round((completedSteps / totalSteps) * 100);

  return (
    <div className="mb-8">
      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-600">
            Progress: {completedSteps} of {totalSteps} sections completed
          </span>
          <span className="text-sm font-bold text-primary">
            {progressPercentage}%
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div 
            className="bg-gradient-to-r from-primary to-secondary h-3 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
      </div>

      {/* Step Indicators */}
      <div className="flex justify-between items-center">
        {categories.map((category, index) => {
          const isCompleted = index < completedSteps;
          const isCurrent = index === currentStep;
          const isClickable = index <= completedSteps || index === currentStep;

          const stepClass = [
            'flex flex-col items-center transition-all duration-200',
            isClickable ? 'cursor-pointer hover:opacity-80' : 'cursor-not-allowed'
          ].join(' ');

          const circleClass = [
            'w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold mb-2 transition-all duration-200',
            isCompleted 
              ? 'bg-green-600 text-white' 
              : isCurrent 
                ? 'bg-primary text-white ring-4 ring-primary-light ring-opacity-30' 
                : 'bg-gray-200 text-gray-500'
          ].join(' ');

          const labelClass = [
            'text-xs text-center max-w-20 transition-all duration-200',
            isCurrent 
              ? 'text-primary font-semibold' 
              : isCompleted 
                ? 'text-secondary font-medium'
                : 'text-gray-400'
          ].join(' ');

          const handleStepClick = () => {
            if (isClickable && onStepClick) {
              onStepClick(index);
            }
          };

          return (
            <div key={category} className={stepClass} onClick={handleStepClick}>
              <div className={circleClass}>
                {isCompleted ? (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <span className={labelClass}>
                {getCategoryDisplayName(category)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Helper function to get display names for categories
const getCategoryDisplayName = (category) => {
  const displayNames = {
    physical: 'Physical',
    mental: 'Mental',
    lifestyle: 'Lifestyle',
    digestive: 'Digestive',
    health: 'Health'
  };
  return displayNames[category] || category;
};

export default QuizProgress;
